/**
 * 3-D Secure / PCI DSS badges in the landing footer (throne-of-conquest f963d2d). Shown only on
 * the hosts the deployment lists in `SECURITY_BADGE_DOMAINS` (served by GET /api/site-info as
 * `securityBadgeDomains`; empty by default), once that domain's payment compliance is confirmed.
 */
export interface FooterBadge { slug: string; name: string; icon: string }

/** Icons live in public/payment-methods/ with the card-scheme badges. */
export const SECURITY_BADGES: readonly FooterBadge[] = [
  { slug: '3d-secure', name: '3-D Secure', icon: '3d-secure' },
  { slug: 'pci-dss', name: 'PCI DSS', icon: 'pci-dss' },
];

/** True when `hostname` is one of `domains` or a subdomain of one (case-insensitive). */
export function showSecurityBadges(hostname: string, domains: readonly string[] | undefined): boolean {
  const host = hostname.toLowerCase();
  return (domains ?? []).some((d) => {
    const domain = d.trim().toLowerCase();
    return !!domain && (host === domain || host.endsWith(`.${domain}`));
  });
}
